module.exports = __webpack_public_path__ + "static/img/radio1.403d90e.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/news2/radio1.png
// module id = RZGH
// module chunks = 7